// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__s0g-Y","rootCenter":"LoadMoreObserver_rootCenter__2KLSR","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__7svM4"};